module.exports = __webpack_public_path__ + "img/fondo-banner-principal.cb853f44.png";